import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import "./SummaryCard.css";

import ProfileSummary from "../Common_profile_details_modals/ProfileSummary/ProfileSummary";
import ChooseOptionModal from "../Common_profile_details_modals/ChooseOptionModal/ChooseOptionModal";

const SummaryCard = () => {
  const [profileSummary, setProfileSummary] = useState(
    "Highly motivated Front-end Developer...",
  );
  const [showProfileSummary, setShowProfileSummary] = useState(false);
  const [showChooseOption, setShowChooseOption] = useState(false);

  const openProfileSummary = () => {
    setShowChooseOption(false);
    setShowProfileSummary(true);
  };

  const closeProfileSummary = () => {
    setShowProfileSummary(false);
  };

  const openChooseOption = () => {
    setShowProfileSummary(false);
    setShowChooseOption(true);
  };

  const closeChooseOption = () => {
    setShowChooseOption(false);
  };

  return (
    <>
      <Card className="profile-card-pattern">
        <Card.Body className="profile-card-pattern__body">
          <div className="profile-card-pattern__header">
            <h3 className="profile-card-pattern__title">Profile summary</h3>

            <div>
              <Button variant="link" className="profile-card-pattern__btn-edit">
                <span
                  className="resume-card__delete-icon"
                  style={{ cursor: "pointer", fontSize: "16px" }}
                >
                  🗑️
                </span>
              </Button>

              <Button
                variant="link"
                className="profile-card-pattern__btn-edit"
                onClick={openProfileSummary}
              >
                <span className="header-card__edit-icon">✏️</span>
              </Button>
            </div>
          </div>

          <p className="profile-summary-text">{profileSummary}</p>
        </Card.Body>
      </Card>

      {/* Profile Summary Modal */}
      <ProfileSummary
        show={showProfileSummary}
        handleClose={closeProfileSummary}
        openChooseOption={openChooseOption}
        summary={profileSummary}
        setSummary={setProfileSummary}
      />

      {/* Choose Option Modal */}

      <ChooseOptionModal
        show={showChooseOption}
        handleClose={closeChooseOption}
        setProfileSummary={setProfileSummary}
        openProfileSummary={openProfileSummary}
      />
    </>
  );
};

export default SummaryCard;
